import { Box, Typography } from '@mui/material';
import { convertToHtml } from '@/utils';

interface Props {
    description: string | string[];
}

export default function FormFieldDescription({ description }: Props) {
    return (
        <Box sx={{ padding: '0px 16px 0px 0px', marginTop: '12px' }}>
            <Typography
                dangerouslySetInnerHTML={{
                    // Older questions can store their description as lines
                    __html: convertToHtml(
                        Array.isArray(description) ? description.join('\n') : description,
                    ),
                }}
                sx={{ display: 'block' }}
                variant="body3"
            />
        </Box>
    );
}
